import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navBarDefaultVariants = {}
const navBarCompoundVariants = []

const navBarSlotNames = [
  [
    "root",
    "NavBar__root"
  ],
  [
    "menu",
    "NavBar__menu"
  ],
  [
    "drawer",
    "NavBar__drawer"
  ],
  [
    "brand",
    "NavBar__brand"
  ],
  [
    "divider",
    "NavBar__divider"
  ],
  [
    "subMenu",
    "NavBar__subMenu"
  ]
]
const navBarSlotFns = /* @__PURE__ */ navBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navBarDefaultVariants, getSlotCompoundVariant(navBarCompoundVariants, slotName))])

const navBarFn = memo((props = {}) => {
  return Object.fromEntries(navBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navBarVariantKeys = []
const getVariantProps = (variants) => ({ ...navBarDefaultVariants, ...compact(variants) })

export const navBar = /* @__PURE__ */ Object.assign(navBarFn, {
  __recipe__: false,
  __name__: 'navBar',
  raw: (props) => props,
  variantKeys: navBarVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, navBarVariantKeys)
  },
  getVariantProps
})